module.exports = __webpack_public_path__ + "494ff3e4.svg";